import AnalyticsInterface from './analyticsInterface'

class ContentAnalytics extends AnalyticsInterface {
  static EVENTS = {
    SELECT_CONTENT: 'select_content'
  }

  static CONTENT_ID_ATTRIBUTE = 'data-content-id'
  static CONTENT_TYPE_ATTRIBUTE = 'data-content-type'

  constructor(ga4) {
    super(ga4)
    this.initialize()
  }

  initialize() {
    document.addEventListener('click', this.handleClick.bind(this))
  }

  handleClick(event) {
    const clickedElement = event.target.closest(
      `[${ContentAnalytics.CONTENT_ID_ATTRIBUTE}][${ContentAnalytics.CONTENT_TYPE_ATTRIBUTE}]`
    )
    if (clickedElement) {
      const contentId = clickedElement.getAttribute(ContentAnalytics.CONTENT_ID_ATTRIBUTE)
      const contentType = clickedElement.getAttribute(ContentAnalytics.CONTENT_TYPE_ATTRIBUTE)
      if (!contentId || !contentType) return
      this.selectContent(contentId, contentType)
    }
  }

  selectContent(contentId, contentType) {
    if (!contentId || !contentType) return
    this.track(ContentAnalytics.EVENTS.SELECT_CONTENT, { contentId, contentType })
  }
}

export default ContentAnalytics
